<template>
    <div>
        <div class="debug-panel" v-if="debug">
            <button class="spawn" @click="spawnConfetti( confettiAmount )">Spawn confetti</button>
            <p>confettiAmount: {{ confettiAmount }}</p>
            <button @click="addConfetti(-50)" class="amount-edit">-50</button><button @click="addConfetti(50)" class="amount-edit">+50</button>
        </div>

        <div class="confetti-container" ref="canvasContainer"></div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import Confetti from '@/vendor/mrynk/Confetti';
    import PIXIManager from '@/vendor/mrynk/PIXIManager';

    export default {
        props: {
            debug: {
                type: Boolean,
                default: false
            }
        },

        data()
        {
            return {
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,

                pixiManager: null,
                confetti: null,
                confettiAmount: 50
            };
        },

        computed:
        {
            confettiIncrease()
            {
                if( innerWidth > 420 )
                {
                    return 50;
                }

                return 25;
            },

            confettiAreaSize()
            {
                return Math.min( 700, innerWidth );
            }
        },

        mounted()
        {
            this.setupPixiCanvas();

            window.addEventListener( 'resize', this.resize );
        },

        methods: {
            resize()
            {
                this.innerWidth = window.innerWidth;
                this.innerHeight = window.innerHeight;

                this.pixiManager.resize( this.innerWidth, this.innerHeight );
            },

            addConfetti( pNum )
            {
                this.confettiAmount += pNum;
            },

            setupPixiCanvas()
            {
                this.pixiManager = new PIXIManager({ width: innerWidth, height: innerHeight });
                this.confetti = new Confetti();

                this.pixiManager.stage.addChild( this.confetti.sprite );
                this.$refs.canvasContainer.appendChild( this.pixiManager.canvas );
            },

            spawnConfetti( pAmount )
            {
                this.confetti.spawn( pAmount, this.confettiAreaSize, this.confettiAreaSize, { x: innerWidth / 2, y: innerHeight * 0.45 });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/components/Confetti.vue